// extracted by mini-css-extract-plugin
module.exports = {"item":"Example_style_item__2UHFM","title":"Example_style_title__2zXZ1","para":"Example_style_para__3eyWm"};